import BaseService from '../../BaseService'

export default class GPService extends BaseService {

  constructor() {
    super('gp')
  }
}
